;
define("store_locator_list_all.tpl", function(){});

